module.exports = [
	{
		"name": "Platform",
		"id": "platform",
		"dropdownClass": "platformDropdown",
		"childrens": [
			{
				"componentType": "list",
				"title": "Modern Identity Platform",
				"description": "The enterprise-grade platform for modern identity. <a href=\"https://auth0.com/how-it-works\" rel=\"external\">Read more</a>",
				"key": "platform-list",
				"titleHref": "https://auth0.com/how-it-works",
				"twoColLayoutBig": true,
				"items": [
					{
						"name": "Lock",
						"description": "The Auth0 Login Box. Secure your websites and mobile apps.",
						"id": "lock",
						"href": "https://auth0.com/lock",
						"icon": "lock"
					},
					{
						"name": "Breached Passwords Detection",
						"description": "Protect your users and services from password leaks.",
						"id": "breached-passwords",
						"href": "https://auth0.com/breached-passwords",
						"icon": "breached"
					},
					{
						"name": "Passwordless",
						"description": "Allow users to login without the need to remember a password.",
						"id": "passwordless",
						"href": "https://auth0.com/passwordless",
						"icon": "passwordless"
					},
					{
						"name": "Multifactor Authentication",
						"description": "The most usable and friction-free multifactor authentication experience.",
						"id": "guardian",
						"href": "https://auth0.com/multifactor-authentication",
						"icon": "multifactor"
					}
				]
			}
		],
		"footerHighlight": true,
		"footerLinks": [
			{
				"id": "read-case-studies",
				"name": "<span>Introducing Auth0 Extend:</span> Better platform extensibility for your SaaS.",
				"href": "https://auth0.com/extend",
				"icon": "extend",
				"external": true
			}
		]
	},
	{
		"name": "Solutions",
		"id": "solutions",
		"dropdownClass": "solutionsDropdown",
		"twoBlockLayout": true,
		"childrens": [
			{
				"componentType": "list",
				"title": "Use Cases",
				"key": "use-cases-list",
				"stackedList": true,
				"items": [
					{
						"name": "For your Customers",
						"customClass": "solutionsItem-b2c",
						"icon": "b2c",
						"id": "b2c",
						"href": "https://auth0.com/b2c-customer-identity-management",
						"alt": "B2C icon"
					},
					{
						"name": "For your Business Partners",
						"customClass": "solutionsItem-b2b",
						"icon": "b2b",
						"id": "b2b",
						"href": "https://auth0.com/b2b-enterprise-identity-management",
						"alt": "B2B icon"
					}
				]
			},
			{
				"componentType": "list",
				"title": "Solutions",
				"key": "solutions-list",
				"highlight": true,
				"subItems": [
					{
						"titleList": "INDUSTRIES",
						"items": [
							{
								"name": "Retail",
								"id": "retail",
								"href": "https://auth0.com/learn/retail",
								"external": true
							},
							{
								"name": "Healthcare",
								"id": "healthcare",
								"href": "https://auth0.com/learn/why-hipaa-compliance-is-vital-your-business",
								"external": true
							},
							{
								"name": "Telecommunications",
								"id": "telecommunications",
								"href": "https://auth0.com/learn/telecommunications-industry",
								"external": true
							},
							{
								"name": "More",
								"id": "more-solutions",
								"href": "https://auth0.com/customers#categories",
								"external": true
							}
						]
					}
				]
			}
		],
		"footerLinks": [
			{
				"id": "read-case-studies",
				"name": "Read our Case Studies",
				"href": "https://auth0.com/learn/#case-studies",
				"icon": "blog",
				"external": true
			}
		]
	},
	{
		"name": "Why Auth0",
		"id": "why-auth0",
		"dropdownClass": "whyDropdown",
		"twoBlockLayout": true,
		"childrens": [
			{
				"componentType": "list",
				"title": "Company",
				"key": "company-list",
				"items": [
					{
						"name": "Customers",
						"id": "customers",
						"href": "https://auth0.com/customers"
					},
					{
						"name": "Security, Privacy & Compliance",
						"id": "security",
						"href": "https://auth0.com/security"
					},
					{
						"name": "High Availability",
						"id": "availability",
						"href": "https://auth0.com/availability-trust"
					}
				]
			},
			{
				"componentType": "list",
				"title": "Resources",
				"key": "resources-list",
				"twoColLayout": true,
				"highlight": true,
				"titleHref": "https://auth0.com/resources",
				"external": true,
				"items": [
					{
						"name": "Whitepapers",
						"id": "whitepapers",
						"href": "https://auth0.com/resources/whitepapers",
						"external": true
					},
					{
						"name": "Videos",
						"id": "videos",
						"href": "https://auth0.com/resources/videos",
						"external": true
					},
					{
						"name": "Ebooks",
						"id": "ebooks",
						"href": "https://auth0.com/resources/ebooks",
						"external": true
					},
					{
						"name": "Blog",
						"id": "blog",
						"href": "https://auth0.com/blog/business",
						"external": true
					},
					{
						"name": "Webinar",
						"id": "webinar",
						"href": "https://auth0.com/resources/webinars"
					},
					{
						"name": "Case Studies",
						"id": "case-studies",
						"href": "https://auth0.com/learn/#case-studies",
						"external": true
					}
				]
			}
		]
	},
	{
		"name": "Developers",
		"id": "developers",
		"dropdownClass": "developersDropdown",
		"twoBlockLayout": true,
		"childrens": [
			{
				"componentType": "list",
				"title": "Documentation",
				"key": "documentation-list",
				"titleHref": "https://auth0.com/docs",
				"external": true,
				"subItems": [
					{
						"titleList": "GET STARTED",
						"items": [
							{
								"name": "Javascript",
								"id": "javascript",
								"href": "https://auth0.com/docs/quickstart/spa/vanillajs",
								"icon": "javascript",
								"external": true
							},
							{
								"name": "iOS",
								"id": "ios",
								"href": "https://auth0.com/docs/quickstart/native/ios-swift",
								"icon": "ios",
								"external": true
							},
							{
								"name": "Android",
								"id": "android",
								"href": "https://auth0.com/docs/quickstart/native/android",
								"icon": "android",
								"external": true
							},
							{
								"name": "All Quickstarts",
								"id": "all-quickstarts",
								"href": "https://auth0.com/docs/quickstart",
								"icon": "quickstarts",
								"external": true
							}
						]
					},
					{
						"titleList": "SECTIONS",
						"items": [
							{
								"name": "APIs",
								"id": "apis",
								"href": "https://auth0.com/docs/api",
								"external": true
							},
							{
								"name": "Protocols",
								"id": "protocols",
								"href": "https://auth0.com/docs/protocols",
								"external": true
							},
							{
								"name": "Libraries",
								"id": "libraries",
								"href": "https://auth0.com/docs/libraries",
								"external": true
							},
							{
								"name": "Identity Providers",
								"id": "identity-providers",
								"href": "https://auth0.com/docs/identityproviders",
								"external": true
							}
						]
					}
				]
			},
			{
				"componentType": "list",
				"title": "Resources",
				"key": "resources-list",
				"highlight": true,
				"items": [
					{
						"name": "Open Source",
						"id": "open-source",
						"href": "https://auth0.com/opensource"
					},
					{
						"name": "Community",
						"id": "community",
						"href": "https://community.auth0.com/"
					},
					{
						"name": "Auth0 Blog",
						"id": "blog-tech",
						"href": "https://auth0.com/blog/tech/",
						"external": true
					},
					{
						"name": "Knowledge Base",
						"id": "knowledge-base",
						"href": "https://auth0.com/learn"
					},
					{
						"name": "Identity Glossary",
						"id": "indentity-glossaryt",
						"href": "https://auth0.com/identity-glossary"
					}
				]
			}
		],
		"footerLinks": [
			{
				"id": "latest-blog",
				"name": "<b>Latest from Auth0 Blog:</b> ",
				"icon": "blog",
				"external": true
			}
		]
	},
	{
		"name": "Pricing",
		"id": "pricing",
		"href": "https://auth0.com/pricing"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/menu-items.json
// module id = 93
// module chunks = 0